import { createFeatureSelector, createSelector } from '@ngrx/store';
import { adapter, DocumentTypeState } from './document-type.reducer';

export const selectDocumentTypeState = createFeatureSelector<DocumentTypeState>('documentTypes');

export const { selectAll: selectAllDocumentTypes } = adapter.getSelectors(selectDocumentTypeState);

export const selectDocumentTypes = selectAllDocumentTypes;
export const selectDocumentTypeLoading = createSelector(selectDocumentTypeState, (state) => state.loading);
export const selectDocumentTypeError = createSelector(selectDocumentTypeState, (state) => state.error);
